module.exports = __webpack_public_path__ + "img/pic2.14e87588.jpg";